const normalize = text => (text || "").toString().normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase()

export const matches = (query, ...fields) => {
  const words = normalize(query).split(/\s+/).filter(Boolean)
  if (words.length === 0) return true
  const haystack = fields.map(normalize).join(" ")
  return words.every(word => haystack.includes(word))
}
